import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms"

export function deleteAccountValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
  
      let CONFIRM_REGEX = /\bEXPLORER\b/
      return CONFIRM_REGEX.test(control.value) ? null : {confirm: true}
    }
  }
  